import React from "react";
import { useTranslation } from "react-i18next";

import { Box } from "@mui/material";
import propTypes from "prop-types";

import sarIcon from "../assets/icons/sar.svg";
import { formatDisplayNumber } from "../utils/numberFormatting";

const CurrencyAmount = ({ value, prefix = "", iconSize = "0.82em", sx = {} }) => {
  const { t } = useTranslation();

  return (
    <Box
      component="span"
      dir="ltr"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "0.22em",
        fontVariantNumeric: "lining-nums tabular-nums",
        unicodeBidi: "isolate",
        ...sx,
      }}
    >
      <Box component="span">
        {prefix}
        {formatDisplayNumber(value)}
      </Box>
      <Box
        component="span"
        role="img"
        aria-label={t("currency.sar")}
        sx={{
          display: "inline-block",
          flex: "0 0 auto",
          width: iconSize,
          height: iconSize,
          backgroundColor: "currentColor",
          WebkitMaskImage: `url(${sarIcon})`,
          maskImage: `url(${sarIcon})`,
          WebkitMaskPosition: "center",
          maskPosition: "center",
          WebkitMaskRepeat: "no-repeat",
          maskRepeat: "no-repeat",
          WebkitMaskSize: "contain",
          maskSize: "contain",
        }}
      />
    </Box>
  );
};

CurrencyAmount.propTypes = {
  value: propTypes.oneOfType([propTypes.number, propTypes.string]).isRequired,
  prefix: propTypes.string,
  iconSize: propTypes.oneOfType([propTypes.number, propTypes.string]),
  sx: propTypes.object,
};

export default CurrencyAmount;
